// extracted by mini-css-extract-plugin
module.exports = {"icon":"FavoriteButton_icon__1_0HK","favorite":"FavoriteButton_favorite__KKk_A"};